import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Paperclip = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Paperclip({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.4693 4.53034C16.3814 3.44252 14.6177 3.44252 13.5299 4.53034L5.27992 12.7803C3.50175 14.5585 3.50175 17.4415 5.27992 19.2197C7.05809 20.9979 9.94109 20.9979 11.7193 19.2197L20.1157 10.8232C20.311 10.628 20.6276 10.628 20.8228 10.8232L21.1764 11.1768C21.3716 11.3721 21.3716 11.6886 21.1764 11.8839L12.7799 20.2803C10.416 22.6443 6.58322 22.6443 4.21926 20.2803C1.8553 17.9164 1.8553 14.0836 4.21926 11.7197L12.4693 3.46968C14.1429 1.79608 16.8563 1.79608 18.5299 3.46968C20.2035 5.14329 20.2035 7.85674 18.5299 9.53034L10.2799 17.7803C9.29667 18.7636 7.70251 18.7636 6.71926 17.7803C5.73601 16.7971 5.73601 15.2029 6.71926 14.2197L14.6157 6.32324C14.811 6.12797 15.1276 6.12797 15.3228 6.32324L15.6764 6.67679C15.8716 6.87205 15.8716 7.18863 15.6764 7.38389L7.77992 15.2803C7.38246 15.6778 7.38246 16.3222 7.77992 16.7197C8.17738 17.1171 8.8218 17.1171 9.21926 16.7197L17.4693 8.46968C18.5571 7.38186 18.5571 5.61816 17.4693 4.53034Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'paperclip-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Paperclip;
